import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const BudgetCompletedIcon = ({ size, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg },
    React.createElement("rect", { width: "14", height: "14", x: "3", y: "3", fill: "#D3DDE6", fillRule: "evenodd", rx: "7" })));
export const BudgetCompleted = iconGenerator(BudgetCompletedIcon);
//# sourceMappingURL=BudgetCompleted.js.map